import Image from "next/image";

import { ModelNoImage } from "@/components/ModelNoImage";
import { ModelNoDates } from "@/types/types";
import { getSizesString } from "@/utils/getSizesString";

export function ShowImageModel({ model }: { model: ModelNoDates }) {
  return (
    <div className="aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-3xl">
      {model.presignedUrlImage !== null ?
        <Image
          src={model.presignedUrlImage}
          alt={`Image of ${model.name}`}
          className="object-cover"
          fill={true}
          sizes={getSizesString({
            sm: 100,
            md: 100,
            lg: 50,
            rest: 33,
          })}
        />
      : <ModelNoImage />}
    </div>
  );
}
